<template>
    <div class="shop-manage">
        <div class="left-menu">
            <div class="menu-item" v-for="(item,index) in menu_list" :key="`menu-${index}`">
                <div :class="['parent-item',{active:item.part == curr_menu}]" @click="onMenuClick(item)">
                    <img :src="require(`@/assets/images/shop-manage/${item.icon}`)" alt="" class="item-icon">
                    {{ item.name }}
                </div>
                <template v-if="item.children && item.children.length>0">
                    <div :class="['child-item',{active:child.part === curr_menu}]" v-for="(child,child_index) in item.children" :key="`child-${child_index}`" @click="onMenuClick(child)">{{ child.name }}</div>
                </template>
            </div>
        </div>
        <div class="right-content">
            <order-manage ref="orderManage"
                v-if="curr_menu === 'order' && !is_order_detail" 
                @detail="showOrderDetail" 
                @shipped="showOrderShipped" 
                @apply-order="showOrderExchangeReturn"
                @reject-order="showOrderExchangeReturnReject"
                @apply-exchange="showOrderExchangeConfirm"
                @reject-exchange="showOrderExchangeReject"
                @recive-order="showOrderExchangeRecive"
                @exchange-shipped="showOrderExchangeShipped"
                @show-asset-center="curr_menu='total'"
                @service-detail="showServiceDetail"
            />
            <order-detail :order="curr_order" v-if="is_order_detail" @order-list="showOrderList" @shipped="showOrderShipped" @service-detail="showServiceDetail" />
            <order-shipped v-if="is_order_shipped" :order="curr_order" @shipped="onOrderShipped" @close="onOrderShipped" />
            <!-- 以下 6 个售后操作弹窗接收的是「售后对象」（含 .type/.ord），用独立槽位 curr_service_action，不污染 curr_order -->
            <order-exchange-return :order="curr_service_action" v-if="is_order_exchange_return" @close="is_order_exchange_return=false" />
            <order-exchange-return-reject :order="curr_service_action" v-if="is_order_exchange_return_reject" @close="is_order_exchange_return_reject=false" />
            <order-exchange-confirm :order="curr_service_action" v-if="is_order_exchange_confirm" @close="is_order_exchange_confirm=false" />
            <order-exchange-reject :order="curr_service_action" v-if="is_order_exchange_reject" @close="is_order_exchange_reject=false" />
            <order-exchange-shipped :order="curr_service_action" v-if="is_order_exchange_shipped" @close="is_order_exchange_shipped=false" />
            <order-exchange-recive :order="curr_service_action" v-if="is_order_exchange_recive" @close="is_order_exchange_recive=false" />
            <products v-if="curr_menu === 'products'" />
            <shop-comment-manage v-if="curr_menu === 'shop-comment-manage'" @order-detail="showOrderDetail" />
            <freight v-if="curr_menu === 'freight'" />
            <shop-info v-if="curr_menu === 'info'" ref="info" />
            <asset-center v-if="curr_menu === 'total'" @show-log="onShowLog"  @show-withdraw="onShowWithdraw" @show-card="onShowCardInfo" />
            <money-log v-if="curr_menu === 'money' || (curr_log_type == 2 && curr_menu == 'assets')" :logType="curr_log_type" @show-asset-center="curr_menu='total'" @show-withdraw="onShowWithdraw"  @show-withdraw-log="curr_menu='withdraw_log'" />
            <withdraw v-if="is_show_withdraw" :type="curr_withdraw_type" @close="is_show_withdraw=false" @show-log="onShowLog"  @show-card="onShowCardInfo" />
            <withdraw-log v-if="curr_menu=='withdraw_log'" @show-asset-center="curr_menu='total'" @show-log="onShowLog"></withdraw-log>
            <service-detail v-if="curr_menu === 'service'" 
                :order="curr_service" 
                @order-list="showOrderList"
                @detail="showOrderDetail" 
                @apply-order="showOrderExchangeReturn"
                @reject-order="showOrderExchangeReturnReject"
                @apply-exchange="showOrderExchangeConfirm"
                @reject-exchange="showOrderExchangeReject"
                @recive-order="showOrderExchangeRecive"
                @exchange-shipped="showOrderExchangeShipped"
            />
            <design-list v-if="curr_menu == 'onsale-list'" />
            <warehouse-manage v-if="curr_menu === 'warehouse'" />
            <shop-invoice-manage v-if="curr_menu === 'shop-invoice-manage'" />
            <shop-coupon-manage v-if="curr_menu === 'shop-coupon-manage'" />
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { lockScroll, unlockScroll, forceUnlockScroll } from '@/utils/scrollLock';
import AssetCenter from './components/AssetCenter.vue';
import DesignList from './components/DesignList.vue';
import MoneyLog from './components/MoneyLog.vue';
import OrderDetail from './components/OrderDetail.vue';
import OrderExchangeConfirm from './components/OrderExchangeConfirm.vue';
import OrderExchangeReturn from './components/OrderExchangeOrReturn.vue';
import OrderExchangeReturnReject from './components/OrderExchangeOrReturnReject.vue';
import OrderExchangeRecive from './components/OrderExchangeRecive.vue';
import OrderExchangeReject from './components/OrderExchangeReject.vue';
import OrderExchangeShipped from './components/OrderExchangeShipped.vue';
import OrderManage from './components/OrderManage.vue';
import OrderShipped from './components/OrderShipped.vue';
import Freight from '../Freight/index.vue';
import Products from './components/Products.vue';
import ShopCommentManage from './components/shopCommentManage/index.vue';
import ServiceDetail from './components/ServiceDetail.vue';
import ShopInfo from './components/ShopInfo.vue';
import Withdraw from './components/Withdraw.vue';
import WithdrawLog from './components/WithdrawLog.vue';
import WarehouseManage from './components/WarehouseManage.vue';
import ShopInvoiceManage from './components/shopInvoiceManage/index.vue';
import ShopCouponManage from './components/shopCouponManage/index.vue';

export default {
    components:{
        DesignList,
        OrderManage,
        OrderDetail,
        OrderShipped,
        OrderExchangeReturn,
        OrderExchangeReturnReject,
        OrderExchangeConfirm,
        OrderExchangeReject,
        OrderExchangeShipped,
        OrderExchangeRecive,
        Freight,
        Products,
        ShopCommentManage,
        ShopInfo,
        AssetCenter,
        MoneyLog,
        Withdraw,
        WithdrawLog,
        ServiceDetail,
        WarehouseManage,
        ShopInvoiceManage,
        ShopCouponManage,
    },
    data() {
        return {
            menu_list:[
                {
                    name:'订单列表',
                    icon:'icon-shop-menu-order-list.png',
                    part:'order',
                    type:'components'
                },
                {
                    name:'商品管理',
                    icon:'icon-shop-menu-products.png',
                    part:'products',
                    type:'components',
                    children:[
                        {
                            name:'上架商品',
                            part:'onsale-list',
                            type:'components'
                        },
                        {
                            name:'商品管理',
                            part:'products',
                            type:'components'
                        },
                        {
                            name:'评价管理',
                            part:'shop-comment-manage',
                            type:'components'
                        },
                        {
                            name:'入库管理',
                            part:'warehouse',
                            type:'components'
                        },
                        {
                            name:'运费模板',
                            part:'freight',
                            type:'components'
                        }
                    ]
                },
                {
                    name:'店铺管理',
                    icon:'icon-shop-menu-store.png',
                    part:'info',
                    children:[
                        {
                            name:'店铺信息',
                            part:'info',
                            type:'components'
                        },
                        {
                            name:'店铺首页',
                            part:'shop-index',
                            type:'redirect',
                            routerName:'ShopHome'
                        },
                        {
                            name:'优惠券',
                            part:'shop-coupon-manage',
                            type:'redirect',
                            routerName:'ShopHome'
                        },
                    ]
                },
                {
                    name:'资产中心',
                    icon:'icon-shop-menu-money.png',
                    part:'total',
                    children:[
                        {
                            name:'资产总览',
                            part:'total',
                            type:'components'
                        },
                        {
                            name:'店铺资产',
                            part:'assets',
                            type:'components'
                        },
                        {
                            name:'开票管理',
                            part:'shop-invoice-manage',
                            type:'components'
                        }
                    ]
                }
            ],
            curr_menu:'order',
            is_order_detail:false,
            is_order_shipped:false,
            is_order_exchange_return:false,
            is_order_exchange_return_reject:false,
            is_order_exchange_confirm:false,
            is_order_exchange_reject:false,
            is_order_exchange_shipped:false,
            is_order_exchange_recive:false,
            is_show_withdraw:false,
            is_show_design_list:false,
            curr_order:{},
            curr_service:{},
            // 售后操作弹窗（退货/换货/收货等）的数据槽位，装「售后对象」，与 curr_order 隔离
            curr_service_action:{},
            user_code:'',
            curr_log_type:1,
            curr_withdraw_type:1,
            isMounted: false
        }
    },
    watch:{
        is_order_detail: {
            handler() {
                this.syncQueryToRoute()
            },
            immediate: false
        },
        is_order_shipped: {
            handler() {
                this.syncQueryToRoute()
            },
            immediate: false
        },
        is_show_withdraw: {
            handler() {
                this.syncQueryToRoute()
            },
            immediate: false
        },
        // 关键修复：移除 immediate: true，避免与 mounted 冲突
        '$route.query': {
            handler(newQuery) {
                // 只在非初始化时恢复状态（mounted 已经处理过了）
                if (this.isMounted) {
                    this.restoreStateFromQuery(newQuery)
                }
            },
            immediate: false,  // 改为 false
            deep: true
        },
        curr_menu() {
            this.syncQueryToRoute()
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        },
        // 弹窗开关 → 锁/解锁 body 滚动，阻断「弹窗滚到边界后滚动穿透到页面」
        is_modal_open(val) {
            if (val) {
                lockScroll()
            } else {
                unlockScroll()
            }
        }
        // curr_menu(news,olds){
        //     if(news != olds){
        //         window.scrollTo({
        //             top:0,
        //             behavior: 'smooth'
        //         })
        //     }
        // }
    },
    computed:{
        ...mapState({
            shopInfo:state=>state.shopInfo,
            userInfo:state=>state.userInfo
        }),
        // 本页挂在模板里的 8 个弹窗型组件，任一打开都要锁页面滚动
        is_modal_open(){
            return this.is_order_shipped
                || this.is_order_exchange_return
                || this.is_order_exchange_return_reject
                || this.is_order_exchange_confirm
                || this.is_order_exchange_reject
                || this.is_order_exchange_shipped
                || this.is_order_exchange_recive
                || this.is_show_withdraw;
        }
    },
    beforeDestroy(){
        // 兜底：带弹窗状态直接离开路由时，避免 body 被永久锁死
        forceUnlockScroll()
    },
    async mounted(){
        console.log('this.$route.query',this.$route.query);

        // 1. 先恢复订单/售后数据
        this.restoreOrderFromStorage()
        this.restoreServiceFromStorage()
        
        // 2. 再恢复页面状态
        this.restoreStateFromQuery(this.$route.query)
        
        // 3. 标记已挂载
        this.isMounted = true

        const {uid} = this.$route.query;
        if(uid){
            this.user_code = uid;
        }
        this.restoreOrderFromStorage()
        this.restoreStateFromQuery(this.$route.query)
        // 深链直达（URL 带 shipped/exchangeXxx/showWithdraw）时 watcher 不会触发，这里补一次锁
        if (this.is_modal_open) {
            lockScroll()
        }
        await this.$store.dispatch('getShopInfo') 
        console.log('shopInfo',this.shopInfo);
    },
    methods:{

        restoreStateFromQuery(query) {
            const { 
                menu, detail, shipped, exchangeReturn, exchangeConfirm,
                exchangeReject, exchangeShipped, exchangeRecive,
                showWithdraw, withdrawType, logType
            } = query
            
            if (menu) {
                this.curr_menu = menu
            }
            this.is_order_detail = !!detail
            this.is_order_shipped = !!shipped
            this.is_order_exchange_return = !!exchangeReturn
            this.is_order_exchange_confirm = !!exchangeConfirm
            this.is_order_exchange_reject = !!exchangeReject
            this.is_order_exchange_shipped = !!exchangeShipped
            this.is_order_exchange_recive = !!exchangeRecive
            this.is_show_withdraw = !!showWithdraw
            if (withdrawType) this.curr_withdraw_type = withdrawType
            if (logType) this.curr_log_type = logType

            // 冷直达守卫：深链到子页面但内存与 sessionStorage 均无对应实体对象时，
            // 回退订单列表，避免 OrderDetail/ServiceDetail 拿到空 uuid 调接口报错
            if (this.curr_menu === 'service' && !(this.curr_service && this.curr_service.uuid)) {
                this.curr_menu = 'order'
                this.is_order_detail = false
            }
            if (this.is_order_detail && !(this.curr_order && this.curr_order.uuid)) {
                this.is_order_detail = false
                this.curr_menu = 'order'
            }
        },
        
        // 同步状态到 URL query（关键：这里会改变 URL）
        syncQueryToRoute() {
            const query = { ...this.$route.query }
            
            query.menu = this.curr_menu
            query.detail = this.is_order_detail ? '1' : undefined
            query.shipped = this.is_order_shipped ? '1' : undefined
            query.exchangeReturn = this.is_order_exchange_return ? '1' : undefined
            query.exchangeConfirm = this.is_order_exchange_confirm ? '1' : undefined
            query.exchangeReject = this.is_order_exchange_reject ? '1' : undefined
            query.exchangeShipped = this.is_order_exchange_shipped ? '1' : undefined
            query.exchangeRecive = this.is_order_exchange_recive ? '1' : undefined
            query.showWithdraw = this.is_show_withdraw ? '1' : undefined
            query.withdrawType = this.is_show_withdraw ? this.curr_withdraw_type : undefined
            query.logType = this.curr_log_type
            
            // 清理 undefined 值
            Object.keys(query).forEach(key => {
                if (query[key] === undefined || query[key] === null) {
                    delete query[key]
                }
            })
            
            // 使用 replace 更新 URL（不产生历史记录）
           const currentQueryStr = JSON.stringify(this.$route.query)
            const newQueryStr = JSON.stringify(query)
            
            if (currentQueryStr !== newQueryStr) {
                this.$router.push({ 
                    path: this.$route.path,
                    query 
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        console.error('路由更新失败', err)
                    }
                })
            }
        },
        
        // 持久化订单数据
        saveOrderToStorage(order) {
            if (order) {
                console.log('aaaaa-save-order');
                sessionStorage.setItem('shop_curr_order', JSON.stringify(order))
            }
        },
        
        restoreOrderFromStorage() {
            const orderStr = sessionStorage.getItem('shop_curr_order')
            if (orderStr) {
                try {
                    this.curr_order = JSON.parse(orderStr)
                } catch (e) {
                    sessionStorage.removeItem('shop_curr_order')
                }
            }
        },
        
        clearOrderStorage() {
            sessionStorage.removeItem('shop_curr_order')
        },

        // 持久化售后数据（与订单数据分离，避免互相覆盖）
        saveServiceToStorage(service) {
            if (service && service.uuid) {
                sessionStorage.setItem('shop_curr_service', JSON.stringify(service))
            }
        },
        restoreServiceFromStorage() {
            const serviceStr = sessionStorage.getItem('shop_curr_service')
            if (serviceStr) {
                try {
                    this.curr_service = JSON.parse(serviceStr)
                } catch (e) {
                    sessionStorage.removeItem('shop_curr_service')
                }
            }
        },
        clearServiceStorage() {
            sessionStorage.removeItem('shop_curr_service')
        },
        showServiceDetail(order){
            console.log('service-detail',order);
            // 关键修复：售后对象存入独立槽位 curr_service，绝不覆盖 curr_order（订单对象）
            this.curr_service = order;
            this.saveServiceToStorage(order);
            // 同步订单对象为"该售后单对应的原订单"，供面包屑"订单详情"回跳。
            // 注意：不能只在 curr_order 为空时补全——从"售后中"列表直进售后详情时，
            // curr_order 可能残留上一次访问的无关订单，会导致面包屑跳到错误订单。
            const linkedOrder = order && order.ord ? order.ord : null;
            if (linkedOrder && linkedOrder.uuid) {
                // uuid 相同 → 保留现有 curr_order（来自列表/详情，字段更完整）；
                // uuid 不同或为空 → 必须改写成该售后单的原订单。
                if (!this.curr_order || this.curr_order.uuid !== linkedOrder.uuid) {
                    this.curr_order = linkedOrder;
                    this.saveOrderToStorage(linkedOrder);
                }
            } else if (
                order && order.order_id &&
                this.curr_order && this.curr_order.order_id &&
                order.order_id !== this.curr_order.order_id
            ) {
                // 兜底：ord 关联缺失/无 uuid，但能确认 curr_order 与本售后单不属同一订单
                // → 宁可清空（面包屑走 showOrderDetail 守卫回订单列表），也不跳到错误订单
                this.curr_order = {};
                this.clearOrderStorage();
            }
            this.is_order_detail = false;
            this.curr_menu='service';
        },
        onShowCardInfo(){
            this.curr_menu = 'info';
            setTimeout(()=>{
                this.$refs.info.onBankInfo();
            },500);
        },
        onShowWithdraw({type}){
            console.log('withdrawType',type);
            this.curr_withdraw_type = type;
            this.is_show_withdraw = true;
        },
        onShowLog({type,no_menu=false}){
            console.log('logType',type);
            this.curr_log_type = type;
            if(no_menu) return;
            this.curr_menu = 'money';
        },
        onMenuClick({part}){
            // if(part === 'onsale-list'){
                // this.is_show_design_list = true;
                // return;
            // }
            if(part === 'shop-index'){
                const routeData = this.$router.resolve({
                    name: 'ShopHome',
                    query: { uid: this.user_code }
                });
                window.open(routeData.href, '_blank');
                return;
            }

            if (this.curr_menu === part) {
                this.clearOrderStorage()
                this.resetOrderStates()
                this.syncQueryToRoute()
                return
            }

            if (this.curr_menu !== part) {
                this.clearOrderStorage()
                this.resetOrderStates()
            }

            // 临时注释
            // if(['total','info'].includes(part)) return;
            this.curr_menu = part;
            if(part == 'assets'){
                this.onShowLog({type:2,no_menu:true});
            }
        },
        // 以下 6 个方法接收的 order 实际是「售后对象」（OrderManage/ServiceDetail emit 的售后行数据），
        // 必须写入 curr_service_action，绝不能覆盖 curr_order，否则弹窗关闭后面包屑/后退会用售后 uuid 调订单接口。
        showOrderExchangeShipped(order){
            console.log('order_exchange_shipped',order);
            this.curr_service_action = order;
            this.is_order_exchange_shipped = true;
        },
        showOrderExchangeRecive(order){ 
            console.log('order-exchange-recive',order);
            this.curr_service_action = order;
            this.is_order_exchange_recive = true;
        },
        showOrderExchangeReject(order){
            console.log('order_exchange_reject',order);
            this.curr_service_action = order;
            this.is_order_exchange_reject = true;
        },
        showOrderExchangeConfirm(order){
            console.log('order_exchange_confirm',order);
            this.curr_service_action = order;
            this.is_order_exchange_confirm = true;
        },
        showOrderExchangeReturnReject(order){ 
            console.log('order_exchange_return',order);
            this.curr_service_action = order;
            this.is_order_exchange_return_reject = true;
        },
        showOrderExchangeReturn(order){
            console.log('order_exchange_return',order);
            this.curr_service_action = order;
            this.is_order_exchange_return = true;
        },
        onOrderShipped(opt = {is_refresh:false}){
            console.log('opt--->shipped',opt);
            const {is_refresh} = opt || {};
            if(is_refresh){
                this.$bus.$emit('list-refresh');
                this.is_order_shipped = true;
            }
            this.is_order_shipped = false;
            this.clearOrderStorage()
        },
        showOrderShipped(order){
            console.log('show-order-shipped',order);
            this.curr_order = order;
            this.saveOrderToStorage(order);
            this.is_order_shipped = true;
        },
        showOrderList(){
            this.is_order_detail = false;
            this.curr_menu = 'order';
            this.clearOrderStorage()
            this.clearServiceStorage()
            this.curr_service = {}
            this.curr_service_action = {}
        },
        showOrderDetail(order){
            console.log('order_detail',order);
            // 无参（如 ServiceDetail 面包屑回跳）时保留现有 curr_order，避免被空对象覆盖
            if (order) {
                this.curr_order = order;
                this.saveOrderToStorage(order)
            }
            // 守卫：无有效订单 uuid 时不进详情（否则 OrderDetail 会用空 uuid 调 shopOrderDetail 报错）
            if (!this.curr_order || !this.curr_order.uuid) {
                this.is_order_detail = false;
                this.curr_menu = 'order';
                return;
            }
            this.is_order_detail = true;
            this.curr_menu = 'order';
        },
        resetOrderStates() {
            this.is_order_detail = false
            this.is_order_shipped = false
            this.is_order_exchange_return = false
            this.is_order_exchange_return_reject = false
            this.is_order_exchange_confirm = false
            this.is_order_exchange_reject = false
            this.is_order_exchange_shipped = false
            this.is_order_exchange_recive = false
            this.curr_order = {}
            this.curr_service = {}
            this.curr_service_action = {}
            this.clearOrderStorage()
            this.clearServiceStorage()
        }
    }
}
</script>
<style scoped lang="scss">
    .shop-manage{
        width:100%;
        min-height:calc(100vh - 60px);
        display:flex;
        column-gap:30px;
        background:#f8f9fb;
        .left-menu{
            // width:244px;
            flex:0 0 244px;
            flex-shrink:0;
            min-height:100%;
            overflow-y:auto;
            position:sticky;
            top:0;
            left:0;
            background:#ffffff;
            padding-left:62px;
            padding-right:16px;
            display:flex;
            flex-direction:column;
            .menu-item{
                width:100%;
                display:flex;
                flex-direction:column;
                &:first-child{
                    margin-top:20px;
                }
                .parent-item{
                    width:100%;
                    padding:11px 26px;
                    display:flex;
                    align-items:center;
                    column-gap:8px;
                    color:#1a1a1a;
                    font-size:16px;
                    font-weight:500;
                    cursor:pointer;
                    border-radius:6px;
                    .item-icon{
                        width:22px;
                        height:22px;
                    }
                    &:hover,&.active{
                        background:#f5f5f5;
                    }
                }
                .child-item{
                    margin-left:56px;
                    font-size:16px;
                    font-weight:400;
                    color:#666666;
                    line-height:38px;  
                    cursor:pointer;
                    &:hover,&.active{
                        color:#ff5967;
                    } 
                }
            }
        }
        .right-content{
            flex:1;
            flex-shrink:0;
            // width:100%;
            min-height:100%;
            padding-right:70px;
            margin-top:23px;
            margin-bottom:10%;
            overflow-x:auto;
            overflow-y:hidden;
        }
    }
</style>